import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-bg-items-white mb-16 flex flex-col gap-y-8 p-10 max-md:mb-12 max-md:gap-y-6 max-md:px-3 max-md:py-8',
    description: 'max-sm:prose-p:text-[16px]',
    authorsTitle: 'heading-m-bold mb-6',
    authors: 'flex flex-wrap gap-x-12 gap-y-6 max-md:gap-y-4',
    author: 'flex items-center gap-4',
    authorImageContainer:
      'relative size-20 shrink-0 overflow-hidden rounded-full',
    authorImage: 'object-cover',
    authorInfo: 'flex flex-col gap-1',
    authorName: 'heading-s-bold',
    authorDescription: 'heading-xs'
  }
});
